<header class="header fixed top-0 w-full h-16 bg-white shadow-default pl-8 flex items-center">
  <div class="mr-6 h-full">
    <a class="flex items-center h-full" (click)="navigateHome()">
      <img class="header__img cursor-pointer" src="./assets/img/logo-onmat.svg" alt="Logo onmat"/>
    </a>
  </div>
  <div class="flex items-center" [ngClass]="{ hidden: !userService.isTeacher() }">
    <onmat-language-selector *ngIf="isDemoOnmat !== undefined"></onmat-language-selector>
    <onmat-group-selector *ngIf="isDemoOnmat !== undefined" class="header__groups ml-2"
                          [disabled]="isResultsPage"></onmat-group-selector>
  </div>
  <div class="w-full flex justify-end items-center h-full">
    <div class="flex h-full items-center">
      <ng-container *ngFor="let item of navigation">
        <ng-container *ngIf="item.visible">
          <div
            *ngIf="item.options"
            class="h-full flex items-center justify-center text-center leading-none cursor-pointer hover:text-primary hover:font-bold px-4"
            [class.header__link-active]="url.includes(item.link)"
            [class.text-primary]="url.includes(item.link)"
            [class.font-bold]="url.includes(item.link)"
            [class.pointer-events-none]="(item.link === appRoutes.groups && isDemoOnmat) || (item.link !== appRoutes.groups && !hasGroupsAssigned)"
            [class.text-grisMedio2]="(item.link === appRoutes.groups && isDemoOnmat) || (item.link !== appRoutes.groups && !hasGroupsAssigned)">
            <tekman-select
              [config]="selectConfig"
              placeholder="{{ item.label | translate }}"
              [style]="{ customSelect: 'b-0', trigger: 'border-transparent px-1', container: 'w-auto top-10 right-0', color: '#673E67' }">
              <div class="py-2">
                <ng-container *ngFor="let option of item.options">
                  <div
                    (click)="optionsMenu(option.action)"
                    class="flex options-center px-4 py-2 w-56 hover:font-bold cursor-pointer w-fit justify-start">
                    <svg-icon class="icon-items" [key]="option.icon" size="lg"></svg-icon>
                    <span *ngIf="option.label" class="pl-4 pSmall truncate">{{ option.label | translate }}</span>
                  </div>
                </ng-container>
              </div>
            </tekman-select>
          </div>
          <div
            *ngIf="!item.options"
            class="h-full flex items-center justify-center text-center leading-none cursor-pointer hover:text-primary hover:font-bold px-4"
            (click)="goTo(item)"
            [class.header__link-active]="url.includes(item.link)"
            [class.text-primary]="url.includes(item.link)"
            [class.font-bold]="url.includes(item.link)"
            [class.pointer-events-none]="(item.link === appRoutes.groups && (isDemoOnmat)) || (item.link !== appRoutes.groups && !hasGroupsAssigned)"
            [class.text-grisMedio2]="(item.link === appRoutes.groups && (isDemoOnmat)) || (item.link !== appRoutes.groups && !hasGroupsAssigned)">
            <svg-icon *ngIf="item.icon" [key]="item.icon" size="md"></svg-icon>
            <span *ngIf="item.label">{{ item.label | translate }}</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <hr class="border-l text-grisMedio2 h-3/5 my-4 mr-4"/>
    <div class="h-full flex justify-center items-center">
      <div>
        <button
          type="button"
          aria-haspopup="true"
          aria-controls="dropdown-user-menu"
          aria-expanded="false"
          class="h-full justify-end pr-4"
          [sharedDropdownMenu]="dropdownUserMenu"
          horizontalPosition="right">
          <div
            class="header__profile rounded-full font-bold text-black h-10 w-10 mr-3 text-xl flex items-center justify-center">
            {{ initials | uppercase }}
          </div>
        </button>
      </div>
    </div>
  </div>
</header>

<ng-template #dropdownUserMenu>
  <tekman-dropdown-menu>
    <ul role="menu" id="dropdown-user-menu">
      <li *ngIf="userService.isTeacher()" role="menuitem" (click)="options('leanwords')">
        <a class="dropdown-item">
          <svg-icon key="birrete-white" class="aria-hidden mr-2" size="md"></svg-icon>
          <span>{{ 'f.submenu.help.training' | translate }}</span>
        </a>
      </li>
      <li role="menuitem" (click)="logout()">
        <a class="dropdown-item">
          <svg-icon key="logout" class="aria-hidden mr-2" size="md"></svg-icon>
          <span>{{ 'f.menu.logout' | translate }}</span>
        </a>
      </li>
    </ul>
  </tekman-dropdown-menu>
</ng-template>
